export type DisplayCurrency = "USD" | "EUR";

export function normalizeDisplayCurrency(x: unknown): DisplayCurrency {
  if (x === "EUR") return "EUR";
  return "USD";
}

/** 1 USD → ~0.92 EUR (індикативно, лише для UI). */
export function usdToEurIndicative(usd: number): number {
  return usd * 0.92;
}
